export class CanaisComunicacaoWhatsAppAudio {
  public phone: string;
  public audio: string;
  public guidclientenapis: string;

  constructor() { }
}
